import axios from 'axios'
import userLanguageSelector from '~/tools/localization/userLanguageSelector'
import { memoize, find } from 'lodash'

export function getResults(searchTerm, contentType, isVodOnly) {
    return axios
      .get(`${window.settings.apiBaseUrlCached || window.settings.apiBaseUrl}/search/v1`, {
        params: {
          site: window.settings.internalName,
          searchTerm: searchTerm,
          types: contentType,
          vodOnly: isVodOnly,
          languageCode: userLanguageSelector(),
          userId: JSON.parse(window.localStorage.user).user && JSON.parse(window.localStorage.user).user.userId ? JSON.parse(window.localStorage.user).user.userId : "null"
        },
        requestId: "search",
        headers: {
          "x-api-key": window.settings.baseAPIKey
        }
      })
      .catch(function(thrown) {
        if (axios.isCancel(thrown))
          console.log("Request canceled", thrown.message);
      });
  }

  export const getLayout = memoize(name =>
    axios({
      method: 'GET',
      url: find(window.settings.pages, ['Page-Name', name])['Page-UI'],
      params: { ts: Date.now() }
    }).then(({ data }) => data)
  )